import { STANDARD_QUEUE_TABS, TicketsView, type TicketsViewConfig } from './TicketsView';

const config: TicketsViewConfig = {
  title: 'My Tickets',
  storageKeyFilters: 'cosmos:filters:v2',
  storageKeySort: 'cosmos:sort:v1',
  defaultFilters: {
    assignedTo: 'me',
    status: [],
    // Hide "Complete" (5) and "Complete-Pending Customer" (21).
    excludeStatus: [5, 21],
    queueID: [],
    priority: [],
    search: '',
  },
  queueTabs: STANDARD_QUEUE_TABS,
};

export default function MyTicketsPage() {
  return <TicketsView config={config} />;
}
